var _desc, _defs, _ellipse, _g, _g2, _g3, _g4, _g5, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthOperationsIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 460,
    viewBox: "0 0 640 460",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Ops51 operations illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A clean operations workspace with approval, invoice, and payment elements.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "surface",
    x1: 129,
    y1: 83,
    x2: 511,
    y2: 376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F8FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDEEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "blue",
    x1: 194,
    y1: 125,
    x2: 444,
    y2: 342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3FA0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1976D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "green",
    x1: 393,
    y1: 115,
    x2: 501,
    y2: 228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9BE7B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05690D"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: 66,
    y: 56,
    width: 508,
    height: 374,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 28,
    stdDeviation: 24,
    floodColor: "#021026",
    floodOpacity: 0.28
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: 0,
    y: 0,
    width: 640,
    height: 460,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 18,
    stdDeviation: 18,
    floodColor: "#031632",
    floodOpacity: 0.18
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320,
    cy: 394,
    rx: 206,
    ry: 28,
    fill: "#061328",
    opacity: 0.28
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130 126c0-24.3 19.7-44 44-44h292c24.3 0 44 19.7 44 44v196c0 24.3-19.7 44-44 44H174c-24.3 0-44-19.7-44-44V126Z",
    fill: "url(#surface)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 126c0-24.3 19.7-44 44-44h292c24.3 0 44 19.7 44 44v44H130v-44Z",
    fill: "url(#blue)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 174,
    cy: 126,
    r: 10,
    fill: "#D7ECFF",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 126,
    r: 10,
    fill: "#D7ECFF",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238,
    cy: 126,
    r: 10,
    fill: "#D7ECFF",
    opacity: 0.46
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184 206c0-13.3 10.7-24 24-24h138c13.3 0 24 10.7 24 24v96c0 13.3-10.7 24-24 24H208c-13.3 0-24-10.7-24-24v-96Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 221h96",
    stroke: "#103A66",
    strokeWidth: 14,
    strokeLinecap: "round",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 255h106",
    stroke: "#103A66",
    strokeWidth: 12,
    strokeLinecap: "round",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 286h72",
    stroke: "#103A66",
    strokeWidth: 12,
    strokeLinecap: "round",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 274,
    width: 34,
    height: 34,
    rx: 10,
    fill: "#E8F4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316 291.5l5.5 5.5L331 285",
    fill: "none",
    stroke: "#1976D2",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394 187c0-18.8 15.2-34 34-34h28c18.8 0 34 15.2 34 34v28c0 18.8-15.2 34-34 34h-28c-18.8 0-34-15.2-34-34v-28Z",
    fill: "url(#green)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 202.4l15.4 15.4L464 184",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386 280c0-12.2 9.8-22 22-22h94c12.2 0 22 9.8 22 22v56c0 12.2-9.8 22-22 22h-94c-12.2 0-22-9.8-22-22v-56Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425,
    cy: 308,
    r: 20,
    fill: "#EAF7EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425 296v24M416 302h14c5 0 9 3.6 9 8s-4 8-9 8h-14",
    fill: "none",
    stroke: "#05690D",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466 294h27M466 319h35",
    stroke: "#103A66",
    strokeWidth: 10,
    strokeLinecap: "round",
    opacity: 0.16
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#softShadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102 248c0-11 9-20 20-20h72c11 0 20 9 20 20v46c0 11-9 20-20 20h-72c-11 0-20-9-20-20v-46Z",
    fill: "#ECF8F0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 271,
    r: 16,
    fill: "#05690D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 260h24M165 281h18",
    stroke: "#05690D",
    strokeWidth: 8,
    strokeLinecap: "round",
    opacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M182 314c44 50 228 55 272 3",
    fill: "none",
    stroke: "#8EC5FF",
    strokeWidth: 10,
    strokeLinecap: "round",
    opacity: 0.34
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242 365h156",
    stroke: "#D7ECFF",
    strokeWidth: 16,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthOperationsIllustration);
export default __webpack_public_path__ + "static/media/auth-operations-illustration.ef3ef9a728c730d7b68b6d3d2537e54f.svg";
export { ForwardRef as ReactComponent };